module.exports = __webpack_public_path__ + "img/gondola.a7125e6e.jpg";